import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=2e6f659c&scoped=true"
import script from "./MenuModal.vue?vue&type=script&lang=js"
export * from "./MenuModal.vue?vue&type=script&lang=js"
import style0 from "./MenuModal.vue?vue&type=style&index=0&id=2e6f659c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f659c",
  null
  
)

export default component.exports